// extracted by mini-css-extract-plugin
export default {"wrapper":"overlay-loader_wrapper__weaR5"};